

























import { defineComponent, computed, onMounted } from "@nuxtjs/composition-api";
import { useConfigStore } from "~/stores/extensionApi";
import useCart from "~/modules/checkout/composables/useCart";
import { useCartStore } from "~/modules/checkout/stores/cart";
import { Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default defineComponent({
  name: "TopBarNew",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const cartStore = useCartStore();
    const cartState = computed(() => cartStore.cart);
    const { load } = useCart();
    const configStore = useConfigStore();
    const slickHeaderPomotionOptions = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: true,
      pagination: { clickable: true },
      navigation: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    };

    const configs = computed(() => configStore.getConfigs);

    const freeShipValue = computed(
      () =>
        cartState.value?.extension_attributes?.free_ship ||
        configs.value?.free_ship_value ||
        0
    );

    const totalShipping = computed(() => {
      return cartState.value?.extension_attributes?.total_shipping || 0;
    });

    const priceFreeShip = computed(() => {
      return Number(freeShipValue.value) - Number(totalShipping.value);
    });

    onMounted(async () => {
      await load();
    });

    return {
      slickHeaderPomotionOptions,
      freeShipValue,
      priceFreeShip,
    };
  },
});
